<template>
  <div class="form-submission-row-group">
    <!-- TODO: Rename to FormSubmissionRowGroup -->
    <template v-if="isPresent(group.form_groups)">
      <div
        v-for="childGroup in group.form_groups"
        :key="childGroup.id"
        data-cy="submission-subgroup"
        class="form-submission-row-group__subgroup"
      >
        <div
          v-if="childGroup.title"
          class="form-submission-row-group__title text-grey-80"
          @click="$emit('click')"
        >
          {{ childGroup.title }}
        </div>
        <form-submission-group
          :key="childGroup.id"
          :group="childGroup"
          :values="values"
        />
      </div>
    </template>
    <template v-else-if="isPresent(group.form_fields)">
      <div class="form-submission-row-group__value">
        <template v-if="isGroupMissed(group)">
          <span class="color-brand">{{
            $t("components.formSubmission.rowGroup.missed")
          }}</span>
        </template>
        <template v-else>
          <span v-for="(field, index) in group.form_fields" :key="field.id">
            <template v-if="index === 0">
              <form-submission-field-value :field="field" :values="values" />
            </template>
            <template v-else-if="hasValue(field, values)">
              &nbsp;<b>x</b>&nbsp;
              <form-submission-field-value :field="field" :values="values" />
            </template>
          </span>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import FormSubmissionFieldValue from "@/components/form-submission/FieldValue"

import { isPresent } from "@/lib/utils"
import { MISSED_VALUE } from "@/lib/form-utils"

export default {
  name: "FormSubmissionGroup",

  components: {
    FormSubmissionFieldValue
  },

  props: {
    group: { type: Object, required: true },
    values: { type: Object, required: true },
    level: { type: Number, default: 1 }
  },

  methods: {
    isPresent,

    isGroupMissed(group) {
      return group.form_fields.every(
        field => this.values[field.id]?.value === MISSED_VALUE
      )
    },

    hasValue(field, values) {
      return isPresent(values[field.id]?.value)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.form-submission-row-group {
  width: 100%;
}

.form-submission-row-group__title {
  white-space: nowrap;
  font-weight: $font-weight--semi-bold;
  padding: $size--2 $size--5 $size--2 0;
}

.form-submission-row-group__value {
  padding: $size--2 0;
  display: inline-block;
}

.form-submission-row-group__subgroup {
  display: flex;

  .form-submission-row-group__title {
    padding-right: $size--6;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
